<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                    <p>Existing Customer</p>
                </div>
            </div>
          

      <div class="main">
        <div class="form container">
          <!-- <div class="form-title">
            <div>
              <h3 class="text-center">RVR DIGITAL INFRASTRUCTURES LIMITED</h3>
              <p class="text-center">2ND FLOOR, MAGNA TOWERS, OPP INDIAN OIL BUNK ROAD, MADHAPUR, HYDERABAD - 500 081</p>
            </div>
          </div> -->
          <div class="offers-area">
          </div>
          <div class="form-fields">
            <form [formGroup]="form">
      
              <div class="field">
                <span>Phone<span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <input type="number" class="form-control" [readonly]="PhoneInput" aria-label="Username" formControlName="mobileNo" placeholder="please enter phone number" aria-describedby="basic-addon1">
                    <span style="width: 10px;" *ngIf="form.get('mobileNo').valid"></span>
                    <button *ngIf="form.get('mobileNo').valid && !phoneotp" class="verify" (click)="verifyPhone()" >Click here to get OTP</button>
                    <button class="verify" *ngIf="timer1">{{minutesToDday}} : {{secondsToDday}}</button>
                    <button class="verify" *ngIf="resendOtp1" (click)="verifyPhone()">Click here to resend OTP</button>
                    <button class="verify" *ngIf="phoneverify"><i class="far fa-check-circle pr-1"></i> verified</button>
                  </div>
                  <div class="input-group input-group-sm mt-2 w-100" *ngIf="phone">
                    <input type="number" [(ngModel)]="vphoneOtp" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="enter otp" aria-label="Username" aria-describedby="basic-addon1">
                    <span style="width: 10px;"> </span> <button class="verify" (click)="phoneOtp()">Click here to verify OTP</button>
                  </div>
                </div>
              </div>
      
              <div class="field">
                <span>Name <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <input type="text" class="form-control" aria-label="Username" formControlName="name" placeholder="please enter name" aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
      
              <div class="field">
                <span>Customer Id<span class="star">*</span></span>
                  <div class="input-group input-group-sm">
                    <div class="input-group input-group-sm w-100">
                    <input type="text" class="form-control" formControlName="customerId" placeholder="please enter customer Id" aria-describedby="basic-addon1">
                    <span *ngIf="form.submitted&&(form.get('customerId')?.value==null||form.get('customerId')?.value=='')" class="danger">Customer Id is required</span>
                  </div>
                </div>
              </div>
    
              <div class="field">
                <span>Email <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <input type="text" class="form-control" aria-label="Username" formControlName="email" placeholder="please enter email" aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
      
              <div class="field">
                <span>Application Form For <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <select name="" id="" class="form-select" formControlName="applicationFormFor">
                      <option selected disabled value="">select application form for</option>
                      <option value="Cable">Cable</option>
                      <option value="Internet">Internet</option>
                      <option value="Internet & Cable">Internet & Cable</option>
                      <option value="Upgrade to FTTH">Upgrade to FTTH</option>
                    </select>
                  </div>
                </div>
              </div>
    
              <div class="field free-internet" *ngIf="form.get('applicationFormFor').value == 'Cable'">
                <div class="">
                  <input type="checkbox" (click)="freeInternet($event)">
                  <label for="">Rs.1/- Internet offer</label>
                </div>
              </div>
      
              <div class="field">
                <span>Installation Address <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <textarea name="" id="" cols="30" class="form-control" formControlName="installationAddress" placeholder="please enter installation address" rows="2"></textarea>
                </div>
              </div>
      
              <div class="field">
                <span>Photo <span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('photoUrl')" *ngIf="photoUrl != ''">Remove</button>
                </span>
                <button *ngIf="photoUrlLoading">Loading Image</button>
                <input type="file" id="photoUrl" accept="image/*" hidden="true" (change)="onChange($event,'photoUrl')">
    
                <button *ngIf="photoUrl == '' && !photoUrlLoading" (click)="addImageBtn('photoUrl')">Add Image</button>
                <img [src]="photoUrl" class="url2" *ngIf="photoUrl != ''" alt="">
              </div>
      
              <div class="field">
                <span>Identity Proof<span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('idProofUrl')" *ngIf="idProofUrl != ''">Remove</button>
    
                </span>
                <button *ngIf="idProofUrlLoading">Loading Image</button>
                <input type="file" id="idProofUrl" accept="image/*" hidden="true" (change)="onChange($event,'idProofUrl')">
    
                <button *ngIf="idProofUrl == '' && !idProofUrlLoading" (click)="addImageBtn('idProofUrl')">Add Image</button>
                <img [src]="idProofUrl" class="url1" *ngIf="idProofUrl != ''" alt="">
              </div>
      
              <div class="field">
                <span>Address Proof <span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('addressProofUrl')" *ngIf="addressProofUrl != ''">Remove</button>
    
                </span>
                <button *ngIf="addressProofUrlLoading">Loading Image</button>
                <input type="file" id="addressProofUrl" accept="image/*" hidden="true" (change)="onChange($event,'addressProofUrl')">
    
                <button *ngIf="addressProofUrl == '' && !addressProofUrlLoading" (click)="addImageBtn('addressProofUrl')">Add Image</button>
                <img [src]="addressProofUrl" class="url2" *ngIf="addressProofUrl != ''" alt="">
              </div>
      
              <div class="field ">
                <span>Building Photo<span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('buildingUrl')" *ngIf="buildingUrl != ''">Remove</button>
    
                </span>
                <button *ngIf="buildingUrlLoading">Loading Image</button>
                <input type="file" id="buildingUrl" accept="image/*" hidden="true" (change)="onChange($event,'buildingUrl')">
    
                <button *ngIf="buildingUrl == '' && !buildingUrlLoading" (click)="addImageBtn('buildingUrl')">Add Image</button>
                <img [src]="buildingUrl" class="url1" *ngIf="buildingUrl != ''" alt="">
              </div>
    
    
    
    
    
    
          
    
    
    
              <div formArrayName="deviceInfoList">
                <div *ngFor="let object of form.controls.deviceInfoList['controls'];let i = index;let last = last" [formGroupName]="i">
                  <div class="field">
                    <span>Device Id <span class="star">*</span></span>
                    <div class="input-group input-group-sm">
                      <div class="input-group input-group-sm w-100">
                        <input type="text" class="form-control" aria-label="Username" formControlName="deviceId" placeholder="please enter device Id" aria-describedby="basic-addon1">
                      </div>
                    </div>
                  </div>
          
                  <div class="field ">
                    <span>Device Type <span class="star">*</span></span>
                    <div class="input-group input-group-sm">
                      <div class="input-group input-group-sm w-100">
                        <input type="text" class="form-control" aria-label="Username" formControlName="deviceType" placeholder="please enter device type" aria-describedby="basic-addon1">
                      </div>
                    </div>
                  </div>
          
                  <div class="field">
                    <span>Device Info</span>
                    <div class="input-group input-group-sm">
                      <div class="input-group input-group-sm w-100">
                        <input type="text" class="form-control" aria-label="Username" formControlName="deviceInfo" placeholder="please enter device info" aria-describedby="basic-addon1">
                      </div>
                    </div>
                  </div>
    
    <div class="field">
  <span>
    Device Photo<span class="star">*</span>
    <br>
    <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
    <button 
      (click)="removeDeviceImage(i)" 
      *ngIf="infoList.controls[i].get('devicePhotoUrl')?.value != ''">
      Remove
    </button>
  </span>

  <button 
    *ngIf="infoList.controls[i].get('devicePhotoUrlLoading')?.value">
    Loading Image
  </button>

  <input 
    type="file" 
    id="devicePhotoUrl{{i}}" 
    accept="image/*" 
    hidden="true" 
    (change)="onChangeDevice($event, i)">

  <button 
    *ngIf="infoList.controls[i].get('devicePhotoUrl')?.value == '' 
            && !infoList.controls[i].get('devicePhotoUrlLoading')?.value" 
    (click)="addDeviceImageBtn(i)">
    Add Image
  </button>

  <img 
    [src]="infoList.controls[i].get('devicePhotoUrl')?.value" 
    class="url1" 
    *ngIf="infoList.controls[i].get('devicePhotoUrl')?.value != ''" 
    alt="">
</div>

    
    
    
                  <div class="add-remove-buttons" *ngIf="last">
                    <button (click)="addDeviceInfoList()">add</button>
                    <button *ngIf="i!=0" (click)="removeDeviceInfoList(i)">remove</button>
                  </div>
                  <div class="add-remove-buttons" *ngIf="!last">
                    <button (click)="removeDeviceInfoList(i)">remove</button>
                  </div>
                </div>
            </div>
    
    
    
    
             
      
              <br>
              <!-- <input class="pr-2" type="checkbox" name="" id="" [checked]="isChecked" (click)="checked()"> <p class="term">I have read, understood & accepted the <span class="link">Terms and Conditions.</span></p><br>
              <button (click)="customerRegistration()" class="submit">submit</button> -->
            </form>
          </div>
        </div>
      </div>

            
            </div>
  
        </div>
    </div>
  </div>